// src/components/SaleCancelForm/ReplacementSaleSelector.tsx
import React, { useCallback } from 'react';
import InputField from '../../../components/Forms/Input/InputField';
import { useSaleInvalidation } from '../../../hooks/sale/useSaleInvalidation';

const ReplacementSaleSelector: React.FC = () => {
  const {
    form,
    formErrors,
    updateField,
    setErrors,
    clearErrors,
    searchReplacementSale,
  } = useSaleInvalidation();

  const handleSearch = useCallback(async () => {
    const code = form.replacementGenerationCode?.trim();
    if (!code) {
      setErrors({ replacementSale: 'Required' });
      return;
    }
    clearErrors();
    await searchReplacementSale(code);
  }, [form.replacementGenerationCode, setErrors, clearErrors, searchReplacementSale]);

  return (
    <div className="w-full">
      <InputField
        label="Código de Generación de la Venta de Reemplazo"
        name="replacementSale"
        value={form.replacementGenerationCode ?? ''}
        onChange={(e) => updateField('replacementGenerationCode', e.target.value)}
        iconKey="hash"
        error={formErrors['replacementSale']}
        type="text"
        required
        placeholder="664F9D1B-70DA-427D-93B5-C3C7C4B4B9C7"
      />

      <div className="mt-3 flex justify-end">
        <button
          type="button"
          onClick={handleSearch}
          className="rounded bg-primary px-4 py-2 font-semibold text-white hover:bg-opacity-90"
          title="Buscar venta de reemplazo"
        >
          Buscar Venta
        </button>
      </div>
    </div>
  );
};

export default ReplacementSaleSelector;
